<template>
    <div>
        <table>
            <tr>
                <td>
                    <p-radio v-model="settings.mode" :name="'mode-'+settings.uid" value="duration">Duration</p-radio>
                </td>
                <td>
                    <vue-numeric
                        @input="updateTime"
                        class="short"
                        thousand-separator="'"
                        :min="0"
                        :max="24"
                        currency="h"
                        currency-symbol-position="suffix"
                        v-model="hours"
                        :disabled="settings.mode !== 'duration'"
                    />
                    :
                    <vue-numeric
                        @input="updateTime"
                        class="short"
                        thousand-separator="'"
                        :min="0"
                        :max="59"
                        currency="m"
                        currency-symbol-position="suffix"
                        v-model="minutes"
                        :disabled="settings.mode !== 'duration'"
                    />
                    :
                    <vue-numeric
                        @input="updateTime"
                        class="short"
                        thousand-separator="'"
                        :min="0"
                        :max="59"
                        currency="s"
                        currency-symbol-position="suffix"
                        v-model="seconds"
                        :disabled="settings.mode !== 'duration'"
                    />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>
                    <p-radio v-model="settings.mode" :name="'mode-'+settings.uid" value="confirmation">Confirmation</p-radio>
                </td>
                <td>
                    <input v-model="settings.confirmation" placeholder="Message" :disabled="settings.mode !== 'confirmation'"></td>
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </table>
    </div>

</template>

<script>
import actionMixin from './action.mixin';

export default {
    mixins: [actionMixin],
    watch: {
    },
    methods: {
        updateTime(){
            this.settings.duration = this.hours*3600+this.minutes*60+this.seconds;
        },
    },
    props: [
    ],
    data: function(){return{
        hours: 0,
        minutes: 0,
        seconds: 0
    }},
    beforeMount: function(){
        Vue.set(this.settings, 'inputTypes', ['ExSample','MiniSample','SnapvialSample']);
        //Vue.set(this.settings, 'outputType', 'SnapvialSample');

        this.setDefault('duration', 1); 
        this.setDefault('confirmation', null); 

        this.hours = Math.floor(this.settings.duration / 3600);
        this.minutes = Math.floor(this.settings.duration / 60) % 60;
        this.seconds = this.settings.duration % 60;
        
    },
    mounted(){
        
    }
}

</script>

<style scoped lang="scss">
    .short {
        width: 45px;
    }
</style>

<style lang="scss" src="./action.scss" scoped>